
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function TkOrderBuyerDetailProcess(props) {

    const { selectItems, onInitialized, onApiInitialized } = props;

    const { t } = useTranslation();

    const [detailApi, setDetailApi] = useState();

    useEffect ( () => {

        if ( detailApi && selectItems.length === 1 ) {

            detailApi.refresh ();

        }

    }, [selectItems] );

    return (

        selectItems.length === 1
        ?
            <BasicCrudScreenType
                id = "TkOrderBuyerDetailProcess" 
                view = "TkVwOrderBuyerDetailProcess"
                headerTitle = {t("term.processInfo")}
                onInitialized = {(grid)=> {grid.selectionMode = "None"; if(onInitialized) {onInitialized(grid)}}}
                onApiInitialized = {(api)=> {setDetailApi(api); if(onApiInitialized) {onApiInitialized(api)}}}
                onModifyViewUrl = {(url)=> `${url}/${selectItems[0].orderBuyerDetailId}`}
                noCreate
                noEdit
                noDelete
                noExcel
            />
        :
            <></>
    );

}

export default TkOrderBuyerDetailProcess;
